import { render, staticRenderFns } from "./NewsForm.vue?vue&type=template&id=88794e6c&"
import script from "./NewsForm.vue?vue&type=script&lang=js&"
export * from "./NewsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports